import produce from 'immer';

import {
  CLEAR_MOBILE_APP_SETTINGS,
  FETCH_MOBILE_APP_SETTINGS_FAILURE,
  FETCH_MOBILE_APP_SETTINGS_SUCCESS,
  UPDATE_MOBILE_APP_SETTINGS_FAILURE,
  UPDATE_MOBILE_APP_SETTINGS_SUCCESS,
} from '@actions/mobileAppSettings';

const initialState: IMobileAppSettingsStore = {
  mobileAppSettings: null,
  error: null,
};

export default (state: IMobileAppSettingsStore = initialState, action: any) =>
  produce(state, (draftState: IMobileAppSettingsStore) => {
    switch (action.type) {
      case FETCH_MOBILE_APP_SETTINGS_SUCCESS:
      case UPDATE_MOBILE_APP_SETTINGS_SUCCESS:
        draftState.mobileAppSettings = action.response;
        draftState.error = null;

        return;

      case FETCH_MOBILE_APP_SETTINGS_FAILURE:
      case UPDATE_MOBILE_APP_SETTINGS_FAILURE:
        draftState.error = action.error;

        return;

      case CLEAR_MOBILE_APP_SETTINGS:
        draftState.mobileAppSettings = null;
        draftState.error = null;

        return;
    }
  });
